import React, { useEffect } from 'react';
import SharedButton from '../../components/Shared/SharedButton';
import { useTranslation } from 'react-i18next';
import EmployeeTable from './EmployeeTable';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function EmployeeMain() {
  const navigate = useNavigate();

  const { data: employeesData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();

  useEffect(() => {
    executeFetch("POST", "employees/list", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "employees/list", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "employees/list", { page: 1, per_page: 10 });
  };


  return (
    <>
      <div className=''>
        <div className='flex justify-end mb-2 '>
          <SharedButton
            label={t('Create Employee')}
            icon='pi pi-plus'
            onClick={() => navigate('/manager/payroll/create')}
            className='bg-primary primary-btn'
          />
        </div>
        <EmployeeTable
          data={employeesData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}
